class Alert_JS {
    constructor(pMsg, pType = JFMUI_CONST.ICONS.SUCCESS, pHasIcon = true, pIsdismissible = true) {
        
        this.AlertType  = pType;
        this.Message = pMsg;
        this.Isdismissible = pIsdismissible;
        this.HasIcon = pHasIcon;
        this.Template = '<div class="alert d-flex align-items-center alert-dismissible fade show" role="alert">' +
            '<div class="message">' +
            '</div>' +
            '</div>';
        this.AlertHTML = DOMUtility_JS.createHTMLFromString(this.Template);

        this.init();
    }

    init(){
        let strAlertClass = 'alert-info',
            strBtnClose = this.Isdismissible ? 
                DOMUtility_JS.createHTMLFromString('<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>') : null,
            objHTMLIcon = this.HasIcon ? new Icon_JS({IType:this.AlertType }).generateIcon() : null,
            objHTMLMsgDiv = this.AlertHTML.querySelector('.message');

        switch (this.AlertType) {
            case JFMUI_CONST.ICONS.INFO:
                strAlertClass = 'alert-info';
                break;
            case JFMUI_CONST.ICONS.SUCCESS:
                strAlertClass = 'alert-success';
                break;
            case JFMUI_CONST.ICONS.WARNING:
                strAlertClass = 'alert-warning';
                break;
            case JFMUI_CONST.ICONS.DANGER:
                strAlertClass = 'alert-danger';
                break;
        }
        // add alert type class
        this.AlertHTML.classList.add(strAlertClass);
        if (!!objHTMLMsgDiv) {
            objHTMLMsgDiv.innerHTML = this.Message;
            !!strBtnClose && (objHTMLMsgDiv.insertAdjacentElement('afterEnd',strBtnClose));
            !!objHTMLIcon && (objHTMLMsgDiv.insertAdjacentElement('beforeBegin',objHTMLIcon));
        }
    }
    updateTemplate(pTemplate){
        this.Template = pTemplate;
        this.AlertHTML = DOMUtility_JS.createHTMLFromString(pTemplate);
        this.init();
    }
    show(pSelector) {
        let objHTMLContainer = (pSelector instanceof HTMLElement) ? pSelector : document.querySelector(pSelector);
        !!objHTMLContainer && (objHTMLContainer.insertAdjacentElement('beforeEnd',this.AlertHTML))
        return new bootstrap.Alert(this.AlertHTML);
    }
}